import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { leaveTemplate } from "../../../../Constant/HR/leaveTemplate";
import { leaveTitle } from "../../../../Constant/title";
import { toast } from "react-toastify";
import {
  centerIDPayload,
  checkStatusCodeSuccess,
  rendorBackButton,
} from "../../../../Constant/common";
import { listOfLeaveTemplateApi, deleteLeaveTemplateApi } from "../../../../Api/leaveTemplate";
import { Delete, notFound } from "../../../../Constant";
import { useSelectedCenter } from "../../../CenterContext";
import { usePageLoader } from "../../../../_helper/loading/LoadingContext";
import { Plus, Edit2, Users, GitBranch, AlertCircle, Trash2 } from "react-feather";
import BaseTooltip from "../../../../BaseComponents/BaseTooltip";
import BaseModal from "../../../../BaseComponents/BaseModal";

const LeaveTemplate = () => {
  useEffect(() => {
    document.title = leaveTitle;
  }, []);
  const navigate = useNavigate();
  const [leaveData, setLeaveData] = useState([]);
  const { selectedCenterPayload } = useSelectedCenter();
  const selectedCenter = selectedCenterPayload.center_id;
  const { setLoading } = usePageLoader();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [templateToDelete, setTemplateToDelete] = useState(null);

  const handleDeleteTemplate = () => {
    if (!templateToDelete?.id) return;
    setDeleteLoader(true);
    deleteLeaveTemplateApi(templateToDelete.id)
      .then((res) => {
        if (checkStatusCodeSuccess(res.statusCode)) {
          toast.success(res?.message || "Leave Template deleted successfully");
          setLeaveData((prevData) => prevData.filter((item) => item.id !== templateToDelete.id));
          setShowDeleteModal(false);
          setTemplateToDelete(null);
        } else {
          toast.error(res?.message);
        }
      })
      .catch((e) => toast.error(e?.response?.data?.message || e?.message))
      .finally(() => {
        setDeleteLoader(false);
      });
  };

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    listOfLeaveTemplateApi(
      selectedCenter ? `${centerIDPayload}${selectedCenter}` : `${centerIDPayload}`,
    )
      .then((res) => {
        if (cancelled) return;
        if (checkStatusCodeSuccess(res.statusCode)) setLeaveData(res?.data);
        else {
          setLeaveData([]);
          toast.error(res?.message);
        }
      })
      .catch(() => {
        if (!cancelled) setLeaveData([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [selectedCenter, setLoading]);

  return (
    <div className="animate-fade-in" style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      {/* Header */}
      <div
        className="animate-slide-down"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <div>
          <h1
            style={{
              fontSize: "1.375rem",
              fontWeight: 800,
              margin: 0,
              color: "var(--text-primary)",
            }}
          >
            {leaveTemplate.LEAVE_TEMPLATE}
          </h1>
          <p style={{ margin: 0, fontSize: "0.8125rem", color: "var(--text-muted)", marginTop: 2 }}>
            Configure leave categories, quotas and approval rules
          </p>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <button
            onClick={() => navigate("/createLeaveTemplate")}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "8px 16px",
              borderRadius: 10,
              background: "var(--brand-indigo)",
              border: "none",
              color: "#fff",
              fontSize: "0.875rem",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            <Plus size={15} strokeWidth={2.5} /> {leaveTemplate.CREATE}
          </button>
          {rendorBackButton(() => navigate("/setting"))}
        </div>
      </div>

      {/* Template list */}
      {leaveData?.length > 0 ? (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {leaveData.map((data, i) => (
            <div
              key={data?.id}
              className="animate-slide-up"
              style={{
                animationDelay: `${i * 40}ms`,
                background: "var(--glass-bg)",
                border: "1px solid var(--glass-border)",
                borderRadius: 16,
                padding: "16px 20px",
                display: "flex",
                alignItems: "center",
                gap: 14,
                flexWrap: "wrap",
                transition: "box-shadow 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = "0 8px 24px rgba(99,102,241,0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <div
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: 12,
                  flexShrink: 0,
                  background: "rgba(244,63,94,0.12)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <GitBranch size={20} strokeWidth={1.75} style={{ color: "#f43f5e" }} />
              </div>

              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{ fontWeight: 700, fontSize: "0.9375rem", color: "var(--text-primary)" }}
                >
                  {data?.leave_template_name}
                </div>
                <div style={{ display: "flex", gap: 10, marginTop: 4, flexWrap: "wrap" }}>
                  <span
                    style={{
                      padding: "2px 10px",
                      borderRadius: 999,
                      fontSize: "0.6875rem",
                      fontWeight: 700,
                      background: "rgba(244,63,94,0.1)",
                      color: "#f43f5e",
                    }}
                  >
                    {data?.totalLeave}{" "}
                    {data?.totalLeave === 1 ? leaveTemplate.LEAVE : leaveTemplate.LEAVES}
                  </span>
                  <span
                    style={{
                      padding: "2px 10px",
                      borderRadius: 999,
                      fontSize: "0.6875rem",
                      fontWeight: 700,
                      background: "rgba(16,185,129,0.1)",
                      color: "#10b981",
                    }}
                  >
                    {leaveTemplate.APPLIED_STAFF} {data?.totalAssignStaff}
                  </span>
                </div>
              </div>

              <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
                <BaseTooltip label={leaveTemplate.EDIT_TEMPLATE} color="#b45309">
                  <button
                    onClick={() => navigate(`/editLeaveTemplate/${data?.id}`)}
                    style={{
                      width: 34,
                      height: 34,
                      borderRadius: 9,
                      border: "1px solid var(--glass-border)",
                      background: "rgba(245,158,11,0.08)",
                      color: "#f59e0b",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                  >
                    <Edit2 size={14} strokeWidth={2} />
                  </button>
                </BaseTooltip>
                <BaseTooltip label={leaveTemplate.MANAGE_STAFF} color="#047857">
                  <button
                    onClick={() => navigate(`/manageLeaveStaff/${data?.id}`)}
                    style={{
                      width: 34,
                      height: 34,
                      borderRadius: 9,
                      border: "1px solid var(--glass-border)",
                      background: "rgba(16,185,129,0.08)",
                      color: "#10b981",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                  >
                    <Users size={14} strokeWidth={2} />
                  </button>
                </BaseTooltip>
                <BaseTooltip label={Delete} color="#dc2626">
                  <button
                    onClick={() => {
                      setTemplateToDelete({ id: data?.id, name: data?.leave_template_name });
                      setShowDeleteModal(true);
                    }}
                    style={{
                      width: 34,
                      height: 34,
                      borderRadius: 9,
                      border: "1px solid var(--glass-border)",
                      background: "rgba(220,38,38,0.08)",
                      color: "#dc2626",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                  >
                    <Trash2 size={14} strokeWidth={2} />
                  </button>
                </BaseTooltip>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "60px 20px",
            gap: 12,
            background: "var(--glass-bg)",
            border: "1px solid var(--glass-border)",
            borderRadius: 16,
          }}
        >
          <AlertCircle size={40} style={{ color: "var(--text-muted)", opacity: 0.4 }} />
          <p style={{ color: "var(--text-muted)", margin: 0 }}>{notFound.dataNotFound}</p>
        </div>
      )}

      {/* ── Delete modal ── */}
      <BaseModal
        isOpen={showDeleteModal}
        title={leaveTemplate.DELETE_TEMPLATE}
        submitText="Delete"
        submit={handleDeleteTemplate}
        loader={deleteLoader}
        disabled={deleteLoader}
        toggler={() => {
          if (!deleteLoader) {
            setShowDeleteModal(false);
            setTemplateToDelete(null);
          }
        }}
      >
        <div style={{ display: "flex", alignItems: "flex-start", gap: 12, padding: "4px 0" }}>
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              background: "rgba(220,38,38,0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Trash2 size={16} strokeWidth={2} style={{ color: "#dc2626" }} />
          </div>
          <p
            style={{
              margin: 0,
              fontSize: "0.9375rem",
              color: "var(--text-primary)",
              lineHeight: 1.5,
              whiteSpace: "pre-line",
            }}
          >
            {templateToDelete?.name &&
              leaveTemplate.DELETE_TEMPLATE_MESSAGE + "\n\n" + templateToDelete.name}
          </p>
        </div>
      </BaseModal>
    </div>
  );
};

export default LeaveTemplate;
